import { jwtDecode } from "jwt-decode";

export const getAccessToken = async (msalInstance) => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length) {
    const account = accounts[0];
    msalInstance.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    const response = await msalInstance.acquireTokenSilent(tokenRequest);
    return response?.accessToken;
  }
  return null;
};

export const checkTokenExpiry = (accessToken) => {
  if (!accessToken) return false; 

  try {
    const decodedToken = jwtDecode(accessToken); 
    const expiryTime = decodedToken.exp * 1000; 
    const currentTime = Date.now(); 
    return expiryTime < currentTime; 
  } catch (error) {
    console.error("Invalid token:", error);
    return true; 
  }
};